import angular from 'angular'
import Swal from 'sweetalert2'

class EfOauthLogin {
    static get $inject() {
        return ['$scope', '$state', 'UsuariosService']
    }

    constructor($scope, $state, UsuariosService) {
        this.apply = fun => $scope.$apply(fun)
        this.token = $state.params.token
        this.UsuariosService = UsuariosService
    }

    login(form) {
        this.error = null;
        this.loading = true

        if (form.$valid) {
            this.UsuariosService
                .authorizeAplicacao(this.email, this.password, this.token)
                .then(() => {
                    return Swal.fire({
                        icon: "success",
                        title: "Login com sucesso",
                        timer: 1000,
                        showConfirmButton: false
                    })
                })
                .then(() => window.close())
                .catch(errors => {
                    if (errors.length) return this._handleError(errors[0])
                    
                    console.error(errors)
                })
                .finally(() => this.apply(() => this.loading = false))
        }
    }

    verifyPasswordWithCapsLock(e) {
        const s = String.fromCharCode(e.which)
        const msgCaps = $('#msg-caps')

        if (!(48 <= e.which && e.which <= 57) && e.which != 13)
            if ((s.toUpperCase() === s && !e.shiftKey) || (s.toUpperCase() !== s && e.shiftKey))
                msgCaps.show();
            else
                msgCaps.hide();
    }

    _handleError(error) {
        switch (error.message) {
            case 'invalid_token':
                return this.error = 'Token inválido.'
            case 'expired_token':
                return this.error = 'Token expirado.'
            case 'invalid_credentials':
                return this.error = 'Dados de login incorretos.'
            default:
                return this.error = 'Ocorreu um erro desconhecido'
        }
    }
}

angular.module('eficienciaFiscalModule').component('efOauthLogin', {
    controller: EfOauthLogin,
    template: `
    <header class="header">
        <div id="logo-group">
            <img src="https://res.cloudinary.com/eficienciafiscal/image/upload/f_auto,fl_progressive,q_auto/v1588013281/app/logo-menu.png" alt="Logo do Eficiencia Fiscal" width="155" height="35">
        </div>
    </header>
    <main class="row form-container">
        <form name="form" class="smart-form client-form col-xs-11 col-lg-3" ng-submit="$ctrl.login(form)">
            <header style="font-weight: normal">
                Permitir que a aplicação Coletor XML acesse seus dados.
            </header>
            <div 
                id="login-error"
                class="alert alert-danger fade in fade out no-margin"
                ng-show="$ctrl.error">
                <i class="fa-fw fa fa-times"></i> 
                {{$ctrl.error}}
            </div>
            <fieldset>
                <section>
                    <label class="label" for="email">E-mail</label>
                    <label class="input"> 
                        <i class="icon-append fa fa-user"></i>
                        <input id="email" name="email" type="email" ng-model="$ctrl.email" required>
                    </label>
                </section>
                <section>
                    <label class="label">Senha</label>
                    <label class="input"> <i class="icon-append fa fa-lock"></i>
                        <input 
                            id="password" 
                            name="password" 
                            type="password" 
                            ng-model="$ctrl.password" 
                            ng-keypress="$ctrl.verifyPasswordWithCapsLock($event)"
                            required>
                        <span id="msg-caps" style="display: none">
                        <small class="text-warning">
                            <i class="fa fa-exclamation"></i>
                            CAPS LOCK ativado. </small>
                        </span>
                    </label>

                    <div class="note">
                        <a ui-sref="forgottenPassword">Esqueceu sua senha?</a>
                    </div>
                </section>
            </fieldset>
            <footer>
                <button class="btn btn-primary" ng-disabled="$ctrl.loading">
                    <span ng-show="$ctrl.loading">
                        Entrando...
                        <i class="fa fa-spin fa-circle-o-notch"></i>
                    </span>
                    <span ng-hide="$ctrl.loading">
                        Entrar
                    </span>
                </button>
            </footer>
        </form>
    </main>
    `
})
